import { APICore } from './apiCore'

const api = new APICore()

function getDocumentos (params) {
  const baseUrl = '/documentos'
  return api.get(baseUrl, params)
}

function getDocumentosPreview (params) {
  const baseUrl = '/documentos/preview'
  return api.get(baseUrl, params)
}

function getDocumento (id) {
  const baseUrl = `/documentos/${id}`
  return api.get(baseUrl, {})
}

function getDocumentoPreview (id) {
  const baseUrl = `/documentos/preview/${id}`
  return api.get(baseUrl, {})
}

function addDocumento (params) {
  const baseUrl = '/documentos'
  return api.createWithFile(baseUrl, params)
}

function updateDocumento (params) {
  const baseUrl = '/documentos'
  return api.updateWithFile(baseUrl, params)
}

function deleteDocumento (params) {
  const baseUrl = '/documentos'
  return api.delete(baseUrl, params)
}

export { getDocumentos, getDocumentosPreview, getDocumentoPreview, getDocumento, addDocumento, updateDocumento, deleteDocumento }
